module.exports = __webpack_public_path__ + "static/media/la.9abefa41.svg";